const mimeTypeToExtension: Record<string, string> = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/jpg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/tiff': '.tif',
  'text/csv': '.csv',
  'text/plain': '.txt',
  'audio/wav': '.wav',
  'video/mp4': '.mp4',
  'application/zip': '.zip',
}

const fileTypeToExtension: Record<string, string> = {
  PDF: '.pdf',
  PNG: '.png',
  JPG: '.jpg',
  DOC: '.doc',
  TIF: '.tif',
  GIF: '.gif',
  ZIP: '.zip',
  CSV: '.csv',
  TXT: '.txt',
  HEIC: '.heic',
  WAV: '.wav',
  MP4: '.mp4',
  XLS: '.xls',
}

const knownExtensions = new Set([
  'pdf',
  'png',
  'jpg',
  'jpeg',
  'doc',
  'docx',
  'tif',
  'tiff',
  'gif',
  'zip',
  'csv',
  'txt',
  'heic',
  'wav',
  'mp4',
  'xls',
  'xlsx',
])

interface DownloadFileProps {
  url?: string | null
  fileName?: string | null
  fileType?: string | null
}

export const downloadFile = async ({
  url,
  fileName,
  fileType,
}: DownloadFileProps) => {
  if (!url) {
    return
  }
  const response = await fetch(url, {
    method: 'GET',
  })
  const buffer = await response.arrayBuffer()

  const blobType = response.headers.get('content-type') || undefined
  const href = window.URL.createObjectURL(new Blob([buffer], { type: blobType }))

  const responseExtension = blobType
    ? mimeTypeToExtension[blobType.toLowerCase().split(';')[0]]
    : undefined
  const typeExtension = fileType ? fileTypeToExtension[fileType] : undefined
  const resolvedExtension = typeExtension || responseExtension || ''

  // If fileName is provided but lacks a recognized file extension, append one.
  // Simple includes('.') is not enough — filenames like "CDL 2027.04.03 (back)"
  // contain dots in dates but have no actual file extension.
  if (fileName && resolvedExtension) {
    const lastDotIndex = fileName.lastIndexOf('.')
    const currentExtension = lastDotIndex !== -1 ? fileName.slice(lastDotIndex + 1).toLowerCase() : ''
    if (!knownExtensions.has(currentExtension)) {
      fileName += resolvedExtension
    }
  }

  const link = document.createElement('a')
  link.href = href
  link.download = fileName ?? ''
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.setTimeout(() => window.URL.revokeObjectURL(href), 0)
}
